import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"flex-direction":"column"} }

import bodyCanvas from "../../components/Canvas/CanvasTemplate.vue";
import { Taccuino } from "../../../../EshJSLib/models/patient";
import { updateTaccuino } from "@/../../EshJSLib/services/taccuinoService";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { useRouter } from "vue-router";
import { patientStore } from '@/store/patient';
import { storeToRefs } from "pinia";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'taccuinoDetails',
  setup(__props) {

const router = useRouter();
const showLoading = ref(false);

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const bodyCanvasElement = ref<InstanceType<typeof bodyCanvas> | null>(null);
  const store = patientStore();
const { patient } = storeToRefs(store);
async function saveTaccuino(rowValue: Taccuino) {
  const userInput = await alertModal.value?.openModal("Salvare le modifiche ? ", true);
  if (userInput) {
    showLoading.value = true;
    updateTaccuino(rowValue)
      .then(() => {
        showLoading.value = false;
        store.fetchTaccuinos();
        alertModal.value?.openModal("Salvato con successo! ", false).then(() => router.push(`/Registro/Taccuino`));
      })
      .catch((res) => {
        showLoading.value = false;
        alertModal.value?.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
      });
  }
}

async function resetTaccuino() {
  const userInput = await alertModal.value?.openModal("Ripristina modifiche ?", true);
  if (userInput) {
    bodyCanvasElement.value.erase_dolore();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(bodyCanvas, {
      ref_key: "bodyCanvasElement",
      ref: bodyCanvasElement,
      onOnSave: saveTaccuino,
      onOnReset: resetTaccuino,
      "outline-image": "male"
    }, null, 512),
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512),
    (showLoading.value)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})